import {FC, useState} from "react";
import {Box, BoxProps, IconButton, List, ListItem, ListItemText} from "@mui/material";
import {makeStyles} from "tss-react/mui";
import {Add, Delete} from "@mui/icons-material";
import {AdminInputText} from "./AdminInputText";

const useStyles = makeStyles()((theme) => ({
	attachLinksRoot: {},
	linkInputRow: {
		display: "flex",
		gap: "12px",
		marginBottom: "20px",
		alignItems: "center",
	},
	linkList: {
		display: "flex",
		flexDirection: "column",
		gap: "8px",
		padding: "10px 0",
		"& li:hover": {
			background: theme.palette.grey[200],
			cursor: "pointer"
		},
		"li": {
			borderRadius: "5px",
			background: theme.palette.grey[100],
		}
	},
	deleteIcon: {
		"& svg path": {
			fill: theme.palette.error.main,
			cursor: "pointer"
		}
	}
}));

interface IProps extends Omit<BoxProps, "onChange"> {
	links: string[];
	onChange: (links: string[]) => void;
}

export const AttachLinks: FC<IProps> = ({ links, onChange, className, ...props }) => {
	const { cx, classes } = useStyles();
	const [input, setInput] = useState("");

	const addLink = () => {
		if (!input.trim()) return;
		const updated = [...links, input.trim()];
		onChange(updated);
		setInput("");
	};

	const removeLink = (index: number) => {
		const updated = links.filter((_, i) => i !== index);
		onChange(updated);
	};

	return (
		<Box className={cx(classes.attachLinksRoot, className)} {...props}>
			<Box className={classes.linkInputRow}>
				<AdminInputText onChange={e => setInput(e.target.value)} value={input} label={"Add Link"} />
				<IconButton onClick={addLink}>
					<Add />
				</IconButton>
			</Box>
			<List className={classes.linkList}>
				{links.map((link, i) => (
					<ListItem
						key={i}
						secondaryAction={
							<IconButton
								edge="end"
								className={classes.deleteIcon}
								onClick={() => removeLink(i)}
							>
								<Delete />
							</IconButton>
						}
					>
						<ListItemText primary={link} />
					</ListItem>
				))}
			</List>
		</Box>
	);
};
